/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const useProductQR = () => {
  let urlParams = window.location.href;
  let params = urlParams.split('/');
  console.log(`url in provider:`, params[params?.length - 1]);
  let id = decodeURIComponent(params[params?.length - 1]);
  if (id) {
    id = String(id).trim();
    return id;
  }
};
